/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { LIST_REPORT3 } from "./actionTypes"
import { listReport3Error, listReport3Success } from "./actions"

//Include Both Helper File with needed methods
import { report3NewApi } from "../../../helpers/backend_helper"

function* list(request) {
  try {
    const response = yield call(report3NewApi, request.payload.form)
    if (response === undefined) throw new Error("API error")
    if (response.length === undefined) throw new Error(response)
    yield put(listReport3Success(response))
  } catch (error) {
    console.log(error.message)
    yield put(listReport3Error(error.message))
  }
}

function* report3ListSaga() {
  yield takeEvery(LIST_REPORT3, list)
}

export default report3ListSaga
